import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import PublicApp from "./PublicApp";
import { setApiTokenProvider } from "./api/pricing";
import { AuthGate } from "./auth/AuthGate";
import { acquireIdToken, consumeRedirectResult, getMsalInstance } from "./auth/msal";
import "./index.css";
import "./PublicApp.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element #root not found");
}
const mount: HTMLElement = root;

const isPricingMasterRoute = window.location.pathname.startsWith("/pricing-master");

function renderPublicSite() {
  setApiTokenProvider(null);
  createRoot(mount).render(
    <StrictMode>
      <PublicApp />
    </StrictMode>,
  );
}

function renderPricingMaster() {
  const pca = getMsalInstance();
  setApiTokenProvider(() => acquireIdToken(pca));
  createRoot(mount).render(
    <StrictMode>
      <MsalProvider instance={pca}>
        <AuthGate>
          <App />
        </AuthGate>
      </MsalProvider>
    </StrictMode>,
  );
}

function renderBootError(message: string) {
  createRoot(mount).render(
    <main className="admin-login-shell">
      <section className="admin-login-card">
        <h1>Unable to load Pricing Master sign-in</h1>
        <p className="error">{message}</p>
      </section>
    </main>,
  );
}

async function boot(): Promise<void> {
  if (!isPricingMasterRoute) {
    renderPublicSite();
    return;
  }

  const pca = getMsalInstance();
  await pca.initialize();
  const redirect = await consumeRedirectResult(pca);
  if (redirect?.account) {
    pca.setActiveAccount(redirect.account);
  } else {
    const account = pca.getAllAccounts()[0];
    if (account) {
      pca.setActiveAccount(account);
    }
  }
  renderPricingMaster();
}

void boot().catch((error: unknown) => {
  console.error(error);
  renderBootError(error instanceof Error ? error.message : "Unexpected startup error");
});
